import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 1.3rem;
`

export const IconContainer = styled.div`
    display: flex;
    height: 1.665rem;
`
export const Image = styled.img.attrs({
    src: `${process.env.NEXT_PUBLIC_BASE_PATH}/images/icon-pickup.svg`
})`
    height: 100%;
    width: auto;
`

export const ShipmentContainer = styled.div`
    display: flex;
    flex-direction: column;
    cursor: pointer;
`
export const ShipmentContent = styled.div`
    display: flex;
    font-size: 1rem;
    color: ${ThemeColors.getGrayColor(1)};
    & input {
        border: 0;
    }
`
export const ShipmentSelectorBlock = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 0.8rem;
    cursor: pointer;

    :hover {
        ${ShipmentContent} a {
            color: ${ThemeColors.getGreenColor(1)};
        }
    }
`
export const ShipmentTitle = styled.span`
    color: ${ThemeColors.grayText};
    font-size: 0.75rem;
`
styled.span`
    color: ${ThemeColors.getGrayColor(0.85)};
`
export const SeclectedShipmentTextButton = styled.a`
    color: inherit;
`
